import styled from 'styled-components';
import { rgba } from 'polished';

import { AccountStatus } from '#/api/account';

import { cFA9400, cFF005C } from '#/colors';

import { useAccountView } from '#/features/account/account-context';

interface Props {
  readonly className?: string;
}

export default function AccountStatusBadge(props: Props) {
  const accountView = useAccountView();
  const { status } = accountView;

  if (status.value === 'ACTIVE') return null;

  if (status.docsUrl == null)
    throw new Error(`${status.value} should have URL to docs`);

  const color = STATUS_COLOR_MAP[status.value];

  return (
    <ContainerLink
      href={status.docsUrl}
      target="_blank"
      color={color}
      className={props.className}
    >
      {status.label}
    </ContainerLink>
  );
}

const ContainerLink = styled.a<{ readonly color: string }>`
  display: grid;
  place-items: center;
  gap: 5px;
  height: 18px;
  padding: 4px 6px;

  border: none;
  border-radius: 4px;
  background-color: ${({ color }) => rgba(color, 0.2)};
  color: ${({ color }) => color};

  font-size: 10px;
  font-weight: 700;

  &:hover {
    background-color: ${({ color }) => rgba(color, 0.3)};
  }
`;

const STATUS_COLOR_MAP: Record<Exclude<AccountStatus, 'ACTIVE'>, string> = {
  DELEVERAGE: cFA9400,
  UNHEALTHY: cFA9400,
  LIQUIDATION: cFF005C,
};
